export default "__VITE_ASSET__5587a0d7__"